import { Button, Card } from 'antd';
import i18n from 'i18next';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class MyErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <section className="h-full flex flex-col justify-center items-center bg-gray-100 px-4">
          <Card className="shadow-lg p-6 max-w-lg text-center" variant="borderless">
            <h1 className="text-2xl font-bold text-red-600">
              {i18n.t('errorBoundaryErrorDetected')}
            </h1>
            <p className="text-gray-600 mt-4">{i18n.t('errorBoundarySomethingWentWrong')}</p>
            <Button
              type="primary"
              size="large"
              className="mt-6"
              onClick={() => window.location.reload()}
            >
              {i18n.t('errorBoundaryReload')}
            </Button>
          </Card>
        </section>
      );
    }

    return this.props.children;
  }
}

export default MyErrorBoundary;
